import { render, staticRenderFns } from "./PersonnelSelector.vue?vue&type=template&id=5b444b17&scoped=true"
import script from "./PersonnelSelector.vue?vue&type=script&lang=ts"
export * from "./PersonnelSelector.vue?vue&type=script&lang=ts"
import style0 from "./PersonnelSelector.vue?vue&type=style&index=0&id=5b444b17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b444b17",
  null
  
)

export default component.exports